import React from "react";
import Socials from "./socials";

interface OurTeamProps {
  name: string;
  position: string;
  image: string;
  socialList?: any;
}

function OurTeam({ name, position, image, socialList }: OurTeamProps) {
  return (
    <div className="cht-px-3 cht-py-2 cht-h-full">
      <div className="cht-rounded-[24px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft cht-overflow-hidden cht-h-full cht-flex cht-flex-col cht-transition-all cht-duration-300 hover:cht-border-[#3e57da]/50 hover:cht-shadow-md hover:-cht-translate-y-1 group">
        {/* Header Accent Bar */}
        <div className="cht-h-24 cht-w-full cht-bg-gradient-to-r cht-from-[#3e57da] cht-to-[#1e293b] cht-relative" />

        <div className="cht-px-6 cht-pb-6 cht-pt-0 cht-flex cht-flex-col cht-items-center cht-text-center cht-flex-1">
          {/* Avatar */}
          <div className="-cht-mt-12 cht-mb-4 cht-relative">
            <img
              src={image}
              className="cht-w-24 cht-h-24 sm:cht-w-28 sm:cht-h-28 cht-rounded-full cht-object-cover cht-border-4 cht-border-white cht-shadow-md group-hover:cht-scale-105 cht-transition-transform cht-duration-300"
              alt={name}
              loading="lazy"
            />
          </div>

          <h4 className="!cht-font-heading cht-text-base sm:cht-text-lg !cht-font-bold cht-text-slate-900 cht-mb-1">
            {name}
          </h4>

          <p className="!cht-font-body cht-text-xs sm:cht-text-sm !cht-font-semibold cht-text-[#3e57da] cht-mb-4">
            {position}
          </p>

          {socialList && (
            <div className="cht-mt-auto cht-pt-2">
              <Socials small={true} socials={socialList} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default OurTeam;

